import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import GatewayCard from "./GatewayCard";
import Button from "./Buttons/Button";
import { getAllSubject } from "../services/getAllSubject";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const GatewaySolution = () => {
  const [subjectData, setSubjectData] = useState([]);
  const fetchSubjectData = async () => {
    try {
      const response = await getAllSubject();
      setSubjectData(response.data);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    fetchSubjectData();
  }, []);

  if(!subjectData?.length){ 
    return null;
  }
  return (
    <div className="container mt-5">
      <h5 className="title text-center">
        Subject-Wise Homework and Assignment Help for Students
      </h5>
      <p className="description text-center">Connect with experts across 100+ academic subjects.</p>

      <Swiper
        modules={[Autoplay]}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        style={{ padding: "10px" }}
        loop={true}
        spaceBetween={10}
        breakpoints={{
          0: {
            slidesPerView: 2,
          },
          576: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 6,
          },
        }}
      >
        {subjectData &&
          subjectData?.length > 0 &&
          subjectData.map((item, index) => (
            <SwiperSlide key={index}>
              <GatewayCard {...item} />
            </SwiperSlide>
          ))}
      </Swiper>

      <Link to="/all-subjects">
        <Button text={"View all subjects "} varient="primary" className="mt-4" />
      </Link>
    </div>
  );
};

export default GatewaySolution;
